import React from "react";
import styled from "@emotion/styled";
import FooterImage from "@/assets/img/FooterLogo.png";
import NewFooterImage from "@/assets/footer_logo.svg";
import { useTranslation } from "react-i18next";

const FooterWrapper = styled.div`
	font-size: 14px;
	color: #929292;
	//display: flex;
	justify-content: space-around;
	max-width: 1950px;
	margin: auto;
	min-width: 1095px;
	padding: 3rem 3rem 4rem 3rem;
	align-items: flex-start;
	.footerLogo {
		width: 8rem;
		height: 2.5rem;
		cursor: pointer;
	}
	.footerDescription {
		line-height: 1.6rem;
		margin-top: 1rem;
		margin-right: auto;
	}
`;

export default function Footer() {
	const { i18n } = useTranslation();
	return (
		<FooterWrapper>
			{i18n.language === "ko" && (
				<>
					<img
						className="footerLogo"
						src={NewFooterImage}
						alt="doinglab"
						onClick={() => window.open("https://www.doinglab.com/ko/home/")}
					/>
					<div className="footerDescription">
						<div>
							<span style={{ marginRight: "1rem" }}>
								사업자: 552-88-00440 (대표이사)진송백
							</span>
							<span>
								06621 서울시 서초구 강남대로 53길 8, 마이워크스페이스 타워
								(강남역 타워점) 11층 1호
							</span>
						</div>
						<div>
							<span style={{ marginRight: "1rem" }}>
								전화번호: 02-6959-5657
							</span>
							<span style={{ marginRight: "1rem" }}>
								통신사판매번호: 2020-서울서초-2478
							</span>
							<a
								href="mailto:sales@doinglab.com"
								target="_blank"
								rel="noreferrer"
							>
								<span>이메일: sales@doinglab.com</span>
							</a>
						</div>
						<div>
							<span> © Copyright. (주)두잉랩 All Rights Reserved.</span>
						</div>
					</div>
				</>
			)}
			{i18n.language === "en" && (
				<>
					<img
						className="footerLogo"
						src={NewFooterImage}
						alt="doinglab"
						onClick={() => window.open("https://www.doinglab.com/en/home/")}
					/>
					<div className="footerDescription">
						<div>
							<span>
								Operator: 552-88-00440 (CEO) Songbaek Jin | 06621 11F,
								Gangnam St.Tower Branch, 8, Gangnam-daero 53-gil,
								Seocho-gu, Seoul, Republic of Korea
							</span>
						</div>
						<div>
							<span>
								Phone number: 02-6959-5657 | Telco sales number:
								2020-Seoul Seocho-2478 |{" "}
							</span>
							<a
								href="mailto:sales@doinglab.com"
								target="_blank"
								rel="noreferrer"
							>
								<span>Email: sales@doinglab.com</span>
							</a>
						</div>
						<div>
							<span>
								© Copyright. Doing Lab Co., Ltd. All Rights Reserved.
							</span>
						</div>
					</div>
				</>
			)}
		</FooterWrapper>
		// <FooterWrapper>
		// 	<FooterTitle>(주) 두잉랩</FooterTitle>
		// 	<FooterContentWrapper>
		// 		<p>
		// 			(대표이사) 진송백&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;06151 서울특별시 강남구
		// 			선릉로93길 27, 아름빌딩 5층
		// 		</p>
		// 		<div>
		// 			<FooterLink
		// 				href="https://www.foodlens.ai/policy?type=1"
		// 				target="_blank"
		// 				rel="noreferrer"
		// 			>
		// 				이용약관
		// 			</FooterLink>
		// 			<FooterVerticalDivider>|</FooterVerticalDivider>
		// 			<FooterLink
		// 				href="https://www.foodlens.ai/policy?type=2"
		// 				target="_blank"
		// 				rel="noreferrer"
		// 			>
		// 				개인정보취급방침
		// 			</FooterLink>
		// 		</div>
		// 	</FooterContentWrapper>
		// 	<FooterContentWrapper>
		// 		<FooterContactWrapper>
		// 			<FooterContactText>
		// 				Mail : sales@doinglab.com&nbsp;&nbsp;&nbsp;
		// 			</FooterContactText>
		// 			<FooterContactText>
		// 				Tel : 031-698-9883&nbsp;&nbsp;&nbsp;
		// 			</FooterContactText>
		// 			<FooterContactText>사업자등록번호 : 552-88-00440</FooterContactText>
		// 		</FooterContactWrapper>
		// 	</FooterContentWrapper>
		// 	<FooterContentWrapper last>
		// 		© Copyright. (주)두잉랩 All Rights Reserved.
		// 	</FooterContentWrapper>
		// </FooterWrapper>
	);
}
